import React from 'react';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import './StickyContactBar.css';
import { CONTACT_INFO } from '../constants';

function StickyContactBar() {
  const phoneNumber = CONTACT_INFO.PHONE.VALUE;
  const whatsappMessage = CONTACT_INFO.WHATSAPP.MESSAGE;
  
  return (
    <div className="sticky-contact-bar">
      <a 
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="contact-btn whatsapp-btn"
      >
        <FaWhatsapp className="icon" />
        WhatsApp Us
      </a>
      
      <a 
        href={`tel:${phoneNumber}`}
        className="contact-btn phone-btn"
      >
        <FaPhoneAlt className="icon" />
        {CONTACT_INFO.PHONE.DISPLAY}
      </a>
    </div>
  );
}

export default StickyContactBar;
